// src/components/Toast.js
import React, { useEffect } from "react";

const Toast = ({ transaction, onClose }) => {
  // Función para determinar el estilo, ícono y sonido según el estado
  const getConfig = (status) => {
    switch (status) {
      case "Completado":
        return {
          // Gradiente azul corporativo (igual al botón de Enviar)
          gradient: "bg-gradient-to-r from-blue-900 to-blue-800",
          sound: "/sounds/success.mp3",
          icon: (
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
            </svg>
          )
        };
      case "Cancelado":
        return {
          // Rojo suave
          gradient: "bg-gradient-to-r from-red-400 to-red-500",
          sound: "/sounds/error.mp3",
          icon: (
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
            </svg>
          )
        };
      case "Procesando":
      default:
        return {
          // Ámbar/Naranja suave para indicar que está en espera/proceso
          gradient: "bg-gradient-to-r from-amber-400 to-orange-400",
          sound: "/sounds/success.mp3", // Puedes usar un sonido más neutral si lo deseas
          icon: (
            // Ícono de reloj de arena o spinner
            <svg className="w-4 h-4 animate-spin-slow" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
          )
        };
    }
  };

  const config = getConfig(transaction.status);

  useEffect(() => {
    const notificationSound = new Audio(config.sound);
    
    notificationSound.play().catch((error) => {
      console.warn("Autoplay de audio bloqueado por el navegador:", error);
    });

    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => {
      clearTimeout(timer);
      notificationSound.pause(); 
    };
  }, [config.sound, onClose]);

  return (
    <div className="fixed bottom-32 right-4 sm:right-6 z-[60] flex justify-end pointer-events-none transition-all duration-300 ease-in-out transform hover:scale-105">
      <div
        className={`flex items-center w-[300px] max-w-[calc(100vw-2rem)] p-3 rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] text-white pointer-events-auto ${config.gradient}`}
        role="alert"
      >
        <div className="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-full bg-white/20 mr-3 shadow-inner">
          {config.icon}
        </div>
        
        <div className="flex-1 min-w-0">
          <p className="font-bold text-xs uppercase tracking-wider mb-0.5 text-white/90 truncate">
            Remesa {transaction.status}
          </p>
          <p className="text-sm font-medium truncate">
            {transaction.amount} {transaction.origin_country_code} ➔ {transaction.destination_country_code}
          </p>
        </div>

        <button
          onClick={onClose}
          type="button"
          className="ml-2 -mr-1 p-1.5 text-white/80 hover:text-white rounded-lg focus:ring-2 focus:ring-white/50 focus:outline-none bg-transparent hover:bg-white/10 transition-colors flex-shrink-0"
          aria-label="Cerrar"
        >
          <span className="sr-only">Cerrar</span>
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Toast;

